<template>
  <div class="row">
    <div class="col-lg-2 col-md-3 private-project-border" style="max-height: 750px;overflow-y: scroll;">
      <div class="row mb-2 pb-3" style="border-bottom: 1px solid #f3f3f3" >
        <div class="input-group">
          <span class="input-group-text"><font-awesome-icon icon="filter"  style="color: #1e3e67"/></span>
          <input v-model="searchText" placeholder="Search Project" class="align-items-sm-center form-control" type="search">
        </div>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item" v-for="userProject in userProjects" :key="userProject.id"
             :style="{border: userProject.projectId == selectedProjectId ? '1px solid #56759c' : '',
                     background: userProject.projectId == selectedProjectId ? '#f2f6f9' : ''}">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed" type="button"
                    @click="goToPagesByProject(userProject.projectId, userProject.projectName)">
              <span class="mx-2" style="font-size: 14px">{{userProject.projectName}}</span>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-9 mx-lg-3">
        <div class="row dashboard-border">
          <div class="col-md-8 col-12 align-self-center" >
            <img src="../../assets/icons/projects.png" height="32" width="32"/>

            <span class="mx-2">Project Pages / </span> <span style="color: #56759c;">{{this.selectedProjectName}}</span>
          </div>
          <div class="col-md-4 col-12 text-end align-self-center">
            <button class="btn" type="button" style="background-color: #56759c;color:#ffffff;margin-right: 3px;" @click="openClosePageModal()" data-bs-toggle="modal" data-bs-target="#addPage">
              <font-awesome-icon icon="plus"/>
              <span style="color: #ffffff;font-weight: unset" class="px-1">Add Page</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row modified-table mt-3 table-responsive">
              <table class="table table-bordered table-font table-hover table-scroll">
                <thead>
                <tr>
                  <th>Pages</th>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody style="vertical-align: middle">
                <tr style="width: 10%; cursor: pointer" v-for="pages in projectPages" :key="pages.id" @click="goToPageResource(pages.id, pages.pageName)">
                  <td style="font-weight: bold">{{pages.pageName}}</td>
                  <td>
                    <font-awesome-icon @click="TryUpdatePage(pages)"
                                       data-bs-toggle="modal" data-bs-target="#addPage"
                                       icon="edit"
                                       size="lg" class="update button-hover"
                                       style="cursor: pointer"
                    />
                  </td>
                  <td>
                    <font-awesome-icon @click="TryDeletePage(pages.id)"
                                       icon="trash-alt"
                                       size="lg" class="modified-color-red button-hover"
                                       style="cursor: pointer"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="col-12" v-if="projectPages.length < 1" style="text-align: center">
                <p style="font-size: 18px;">No results found!</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="col-lg-5 col-md-9 mx-lg-2">
      <div class="row dashboard-border">
        <div class="col-md-8 col-12 align-self-center" >
          <img src="../../assets/icons/projects.png" height="32" width="32"/>
          <span class="mx-2">Page Resources / </span> <span style="color: #56759c;">{{this.selectedPageName}}</span>
        </div>
        <div class="col-md-4 col-12 text-end align-self-center">
          <button class="btn" type="button" style="background-color: #56759c;color:#ffffff;margin-right: 3px;" @click="openCloseResourceModal()" data-bs-toggle="modal" data-bs-target="#addResource">
            <font-awesome-icon icon="plus"/>
            <span style="color: #ffffff;font-weight: unset" class="px-1">Add Page Resource</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row modified-table mt-3 table-responsive">
            <table class="table table-bordered table-font table-hover table-scroll">
              <thead>
              <tr>
                <th>Resource</th>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody style="vertical-align: middle">
              <tr style="width: 10%;" v-for="pageres in pageResources" :key="pageres.id" >
                  <td style="font-weight: bold">{{pageres.permissionName}}</td>
                  <td>
                    <font-awesome-icon @click="TryUpdateResource(pageres)"
                                       data-bs-toggle="modal" data-bs-target="#addResource"
                                       icon="edit"
                                       size="lg" class="update button-hover"
                                       style="cursor: pointer"
                    />
                  </td>
                  <td>
                    <font-awesome-icon @click="TryDeleteResource(pageres.id)"
                                       icon="trash-alt"
                                       size="lg" class="modified-color-red button-hover"
                                       style="cursor: pointer"
                    />
                  </td>
              </tr>
              </tbody>
            </table>
            <div class="col-12" v-if="pageResources.length < 1" style="text-align: center">
              <p style="font-size: 18px;">No results found!</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-page :projectId='selectedProjectId' :isActiveProjectPageModal='isActiveProjectPageModal'
              @openClosePageModal="openClosePageModal" :pages-form="pagesForm" :pageId="selectedPageId"
    />
    <add-resource :projectId='selectedProjectId' :pageId="selectedPageId" :isActiveResourceModal='isActiveResourceModal'
              @openCloseResourceModal="openCloseResourceModal" :resources-form="resourcesForm"
    />

    <div class="col-md-2"></div>
  </div>
</template>
<script>

  import {loadingMixin} from "../../utils/mixins";
  import {mapActions, mapState} from "vuex";
  import AddPage from "../../components/ui/AddPage";
  import AddResource from "../../components/ui/AddResource";

  export default {
    name: "Resources",
    mixins: [loadingMixin],
    components: {
      AddResource,
      AddPage,
    },
    data() {
      return {
        selectedProjectId: 0,
        selectedProjectName: "",
        selectedPageId:0,
        selectedPageName:"",
        isActiveProjectPageModal: false,
        isActiveResourceModal: false,
        pagesForm: {
          pageId:0,
          projectId: 0,
          pageName: ""
        },
        resourcesForm:{
          resourceId:0,
          pageId:0,
          projectId: 0,
          permissionName: ""
        },
        searchText:"",

      }
    },

    methods: {
      ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
      ...mapActions('users', ['getUsers']),
      ...mapActions('roles', ['getRoles', 'addRole', 'deleteRole', 'getPermissions', 'getRolePermissions', 'addRolePermission', 'getPermissionsByProject']),
      ...mapActions('pages', ['getProjectPages','getPageResources','deletePage','deleteResource']),

      goToPagesByProject(id , name) {
        this.selectedProjectId = id;
        this.getProjectPages(this.selectedProjectId);
        this.pageResources.length = 0;
        this.selectedProjectName = name;
        this.selectedPageName = "";
      },
      goToPageResource(id ,name) {
        this.selectedPageId = id;
        this.getPageResources(this.selectedPageId);
        this.selectedPageName = name;
      },
      async TryUpdatePage(value) {
        try {
          this.pagesForm.pageId = value.id;
          this.pagesForm.projectId = value.projectId;
          this.pagesForm.pageName = value.pageName;
          this.isActiveProjectPageModal = !this.isActiveProjectPageModal;
        } catch (e) {
          this.$notify({title: "Error", type: "error", text: e.message});

        }
      },
      TryDeletePage(pageId) {
        this.$swal({
          title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to delete page "' + pageId + '" Are you sure?</p>',
          html: "",
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#ec2929d4',
          confirmButtonColor: '#1e3e67',
          confirmButtonText: 'Yes',
        }).then(async (response) => {
          if (response.value) {
            try {
              this.pagesForm.pageId= pageId;
              await this.deletePage(this.pagesForm.pageId);
              await this.getProjectPages(this.selectedProjectId);
              this.$notify({
                title: "Success",
                text: "Page deleted successfully. ",
                type: "success"
              });
            } catch (e) {
              this.$notify({
                title: "Error",
                text: "Failed to delete page.." + e.message,
                type: "error"
              });
            }
          }
        });
      },
      async openClosePageModal() {
        this.pagesForm.pageId = 0;
        this.pagesForm.projectId = '';
        this.pagesForm.pageName= "";
        this.isActiveProjectPageModal = !this.isActiveProjectPageModal;
      },
      async openCloseResourceModal() {
        this.resourcesForm.resourceId = 0;
        this.resourcesForm.pageId = 0;
        this.resourcesForm.projectId = '';
        this.resourcesForm.permissionName= "";
        this.isActiveResourceModal = !this.isActiveResourceModal;
      },

      async TryUpdateResource(value) {
        try {
          this.resourcesForm.resourceId = value.id;
          this.resourcesForm.pageId = value.pageId;
          this.resourcesForm.projectId = value.projectId;
          this.resourcesForm.permissionName = value.permissionName;
          this.isActiveResourceModal = !this.isActiveResourceModal;
        } catch (e) {
          this.$notify({title: "Error", type: "error", text: e.message});

        }
      },

      TryDeleteResource(resourceId) {
        this.$swal({
          title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to delete page "' + resourceId + '" Are you sure?</p>',
          html: "",
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#ec2929d4',
          confirmButtonColor: '#1e3e67',
          confirmButtonText: 'Yes',
        }).then(async (response) => {
          if (response.value) {
            try {
              this.resourcesForm.resourceId= resourceId;
              console.log()
              await this.deleteResource(this.resourcesForm.resourceId);
              await this.getProjectPages(this.selectedProjectId);
              await this.getPageResources(this.selectedPageId);
              this.$notify({
                title: "Success",
                text: "Resource deleted successfully. ",
                type: "success"
              });
            } catch (e) {
              this.$notify({
                title: "Error",
                text: "Failed to delete resource.." + e.message,
                type: "error"
              });
            }
          }
        });
      },
    },

    computed: {
      ...mapState('projects', ['projects', 'project', 'userProject', 'isActiveProjectModal']),
      ...mapState('users', ['userList']),
      ...mapState('pages', ['projectPages', 'pageResources']),

      userProjects: function () {
        return this.projects.filter((post) => {
          return post.projectName.toUpperCase().match(this.searchText.toUpperCase());
        });
      },
    },

    async created() {
      this.showLoading();
      try {
        await this.getProjects();
      } finally {
        this.hideLoading();
      }
    },
  }
</script>


<style scoped>

  .private-project-border{
    padding:12px;
    box-shadow: 0px 3px 10px #ced4da;
    cursor: pointer;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  ul li {
    text-align: center;
    font-size: 16px;
    overflow: hidden;
  }
  .header {
   font-size: 20px;
   color: #383838;
   font-weight: 500;
   font-family: Helvetica,Arial;
  }
  .card-hover:hover {
    box-shadow: 0px 3px 10px #8d8d95 !important;
  }
  .perm-button:hover {
    box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  }
  .perm-button{
    width: 35px !important;
    height: 30px;
    padding: 0px;
  }
  .update {
    color: rgba(33, 128, 12, 0.83);
  }
  .accordion-item{
    margin-bottom: 5px;
  }
  .accordion-button{
    height: 40px;
  }
  .accordion-item:not(:first-of-type) {
    border: 1px solid #dee2e6;
  }
  .accordion-button:focus {
    box-shadow: unset;
  }
  .accordion-button:not(.collapsed)::before {
    background-image: var(--bs-accordion-btn-active-icon);
    transform: rotate(-180deg);;
  }
  .accordion-button:not(.collapsed){
    background-color: unset;
    color: #56759c;
    box-shadow: inset 0 calc(-1 * 1px) 0 #dee2e6;
  }
  .accordion-button::before {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform 0.2s ease-in-out;
  }
  .accordion-button::after {
    display: none;
  }
</style>
